export default __webpack_public_path__ + "src/assets/downloads/flush.mp3";